import React from "react";
import { motion } from "framer-motion";
import ToggleSwitch from "../Users/ToggleSwitch";

interface TaskManagerStatusFilterProps {
  statusFilter:
    | ""
    | "ongoing"
    | "waiting for approval"
    | "completed"
    | "duplicate"
    | "overdue";
  onChange: (
    filter:
      | ""
      | "ongoing"
      | "waiting for approval"
      | "completed"
      | "duplicate"
      | "overdue"
  ) => void;
  resetPagination: () => void;
  handleToggleRepetitiveTasks: (checked: boolean) => void;
  showRepetitiveTasks: boolean;
}

const TaskManagerStatusFilter: React.FC<TaskManagerStatusFilterProps> = ({
  resetPagination,
  statusFilter,
  onChange,
  handleToggleRepetitiveTasks,
  showRepetitiveTasks,
}) => {
  const filters = [
    { key: "", label: "All" },
    { key: "ongoing", label: "Ongoing" },
    { key: "waiting for approval", label: "Waiting for Approval" },
    { key: "completed", label: "Completed" },
    { key: "duplicate", label: "Duplicate" },
    { key: "overdue", label: "Overdue" },
  ] as const;

  return (
    <div className="bg-white rounded-xl overflow-hidden mb-6">
      <div className="grid grid-cols-1 sm:grid-cols-[1fr_auto] gap-3 items-center p-3 w-full">
        {/* Left placeholder so toggle stays right */}
        {!showRepetitiveTasks && (
          <div className="flex flex-wrap justify-center sm:justify-center gap-2">
            {filters.map(({ key, label }) => {
              const isActive = statusFilter === key;

              return (
                <motion.button
                  key={key}
                  onClick={() => {
                    resetPagination();
                    onChange(key);
                  }}
                  className={`
                relative flex items-center space-x-2 px-4 py-1 font-semibold text-xs rounded-lg transition-all duration-200
                ${
                  isActive
                    ? "text-navyBlue-primary shadow-sm"
                    : "text-gray-600 hover:text-gray-900 hover:bg-gray-50 border border-transparent"
                }
              `}
                  whileHover={{ scale: isActive ? 1 : 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <span>{label}</span>

                  {isActive && (
                    <motion.div
                      layoutId="statusIndicator"
                      className="absolute -bottom-1 left-2 right-2 h-[2px] bg-blue-300 rounded-full"
                      transition={{
                        type: "spring",
                        bounce: 0.2,
                        duration: 0.6,
                      }}
                    />
                  )}
                </motion.button>
              );
            })}
          </div>
        )}
        <div className="flex justify-center sm:justify-end">
          <ToggleSwitch
            id="repetitive-toggle"
            checked={showRepetitiveTasks}
            onChange={handleToggleRepetitiveTasks}
            label={"Repetitive Tasks"}
            sizeVariant="xs"
            showIcon={false}
            containerClassName="flex items-center justify-end p-0 bg-transparent border-0"
          />
        </div>
      </div>
    </div>
  );
};

export default TaskManagerStatusFilter;
